import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { getMenuData, MenuItem } from './menu.service.config'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  public getMenuData(): Observable<MenuItem[]> {
    return of(getMenuData())
  }
}
